export const navigationText = {
    "English" : {
        SIGN_OUT_BUTTON : "SIGN OUT"
    },
    "Español" : {
        SIGN_OUT_BUTTON : "SIGN OUT"
    }
} 